import { useEffect, useState } from "react";
import { motion } from "framer-motion";
import { REGISTRATION_URL } from "../lib/config";

export const Header = () => {
  const [scrolled, setScrolled] = useState(false);
  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 40);
    onScroll();
    window.addEventListener("scroll", onScroll, { passive: true });
    return () => window.removeEventListener("scroll", onScroll);
  }, []);

  return (
    <motion.header
      initial={{ y: -80, opacity: 0 }}
      animate={{ y: 0, opacity: 1 }}
      transition={{ duration: 0.9, delay: 0.2, ease: [0.16, 1, 0.3, 1] }}
      className={`fixed inset-x-0 top-0 z-50 transition-colors duration-500 ${
        scrolled ? "border-b border-ivory/10 bg-night/80 backdrop-blur-xl" : "bg-transparent"
      }`}
      data-testid="site-header"
    >
      <div className="mx-auto flex max-w-7xl items-center justify-between px-5 py-4 sm:px-8">
        <a href="#" data-testid="header-logo" className="font-display text-sm font-bold uppercase tracking-[0.22em] text-ivory">
          Fede <span className="text-gold">&</span> Fitness <span className="hidden sm:inline">Italia</span>
        </a>
        <a
          href={REGISTRATION_URL}
          data-testid="header-cta-button"
          className="border border-gold/60 px-5 py-2.5 font-display text-xs font-bold uppercase tracking-[0.18em] text-gold transition-colors duration-300 hover:bg-gold hover:text-night"
        >
          Inizia gratis
        </a>
      </div>
    </motion.header>
  );
};
